import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IMachine } from 'src/app/modules/administration/interfaces/machine';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-machine',
  templateUrl: './filter-machine.component.html',
  styleUrls: ['./filter-machine.component.scss'],
})
export class FilterMachineComponent implements AfterViewInit {
  @Input() public filter: IFilter;

  @Input() public set machineType(machineType: string) {
    this.selectedFilter.machineType = machineType;
    if (this.filter.isForVitalSigns) {
      this.getMachinesForVitalSignsFilter(Number(machineType));
    } else if (machineType !== undefined && (!this.filter.dependsOn || !this.filter.dependsOn.includes('mine'))) {
      this.getMachinesByMachineType(String(machineType));
    } else if (this.filter.dependsOn && this.filter.dependsOn.includes('mine')) {
      this.getMachinesByMachineTypeAndMine();
    }
  }

  @Input() public set mine(mine: string) {
    this.selectedFilter.mine = mine;

    if (mine !== undefined && this.filter.dependsOn && this.filter.dependsOn.includes('mine')) {
      this.getMachinesByMachineTypeAndMine();
    }
  }

  @Output() public machinesChanged: EventEmitter<IMachine[]>;

  public machines: IMachine[];

  public selectedOption: any;

  public selectedFilter: { machineType: string; mine: string };

  constructor(
    private filterHandlerService: FilterHandlerService,
    private cdr: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.machines = [];
    this.machinesChanged = new EventEmitter<IMachine[]>();
    this.selectedFilter = { machineType: null, mine: null };
  }

  /**
   * App after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      this.selectedOption = null;
    });
  }

  /**
   * Function to change selected machine
   *
   * @param $event selected machine
   */
  public changeSelectedOption($event: IMachine[]): void {
    this.machinesChanged.emit($event);
    this.selectedOption = $event;
    const filter = {
      filter_selected: 'filter_machine',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to get machines by machine type
   *
   * @param machineTypes Incoming machine type
   */
  public getMachinesByMachineType(machineTypes: string): void {
    if (machineTypes.length > 0) {
      this.filterHandlerService.getMachineByMachineType(machineTypes).then(
        (machines: IMachine[]) => {
          this.fillMachines(machines);
        },
        () => {},
      );
    } else {
      this.machines = [];
      this.cdr.detectChanges();
    }
  }

  /**
   * Function to get machines by machine type and mine
   */
  public getMachinesByMachineTypeAndMine(): void {
    if (this.selectedFilter.machineType && this.selectedFilter.mine) {
      this.filterHandlerService
        .getMachinesBySelectedMine(Number(this.selectedFilter.mine), Number(this.selectedFilter.machineType))
        .then((machines) => {
          this.fillMachines(machines);
        });
    }
  }

  /**
   * Function to get machines for vital signs
   */
  public getMachinesForVitalSignsFilter(machineTypes: number): void {
    if (machineTypes) {
      this.filterHandlerService.getMachinesForVitalSignsFilter(machineTypes).then(
        (machines: IMachine[]) => {
          this.fillMachines(machines);
        },
        () => {},
      );
    } else {
      this.machines = [];
      this.cdr.detectChanges();
    }
  }

  /**
   * Function to fill dropdown selector with machines
   *
   * @param machines machines to fill
   */
  public fillMachines(machines: IMachine[]): void {
    if (this.filter.multiselect) {
      for (const machine of machines) {
        machine.selectedAllGroup = 'selectedAllGroup';
      }
    }

    this.machines = machines;
    this.cdr.detectChanges();
  }
}
